/* eslint-disable no-shadow,no-param-reassign,global-require,import/no-unresolved */
import i18n from '../../i18n/i18n-config';
import { setLocalStorageItem } from '@/util/local-storage';

const state = {
  sidenavOpen: true,
  locale: 'lt',

  localeIcon: require('@/assets/locale/lt-flag.png'), // 'require' is used to make v-img work with dynamic src attributes
  isTouchDevice: false,
};

const getters = {};

const mutations = {
  store(state, payload) {
    state.sidenavOpen = payload.sidenavOpen === false ? payload.sidenavOpen : true;
    state.locale = payload.locale ? payload.locale : 'lt';
    state.localeIcon = payload.localeIcon
      ? payload.localeIcon
      : require('@/assets/locale/lt-flag.png');
    setLocalStorageItem('settings', JSON.stringify(state));
  },

  update(state, payload) {
    if (payload) {
      state[payload.key] = payload.value;
    }
    setLocalStorageItem('settings', JSON.stringify(state));
  },

  updateLocale(state, payload) {
    state.locale = payload.locale;
    state.localeIcon = payload.localeIcon;
    i18n.locale = payload.locale;
    setLocalStorageItem('settings', JSON.stringify(state));
  },

  setTouchDevice(state) {
    state.isTouchDevice = true;
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
